const ReportGenerator = () => {
  return <div>Report Generator</div>;
};

export default ReportGenerator;
